var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDragIcon = function SvgDragIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 1.5,
    y: 2.75,
    fill: "currentColor",
    fillOpacity: 0.7,
    rx: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 1.5,
    y: 6.25,
    fill: "currentColor",
    fillOpacity: 0.7,
    rx: 0.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 1.5,
    y: 9.75,
    fill: "currentColor",
    fillOpacity: 0.7,
    rx: 0.75
  })));
};
export default SvgDragIcon;